export const policy_programme = [
  {
    id: 1,
    name: 'BNG Housing',
    summary: 'shortsummary/BNG Housing.html',
    link: 'BNG Housing.pdf',
    audio_en: 'audio/en/BNG Housing_en.mp3',
    audio_af: 'audio/af/BNG Housing_af.mp3',
    audio_xh: 'audio/xh/BNG Housing_xh.mp3'
  },
  {
    id: 2,
    name: 'First Home Finance Brochure (Sep 2023)',
    summary: 'shortsummary/First Home Finance Brochure Sep 2023.html',
    link: 'First Home Finance_Booklet.pdf',
    audio_en: 'audio/en/FHF-BROCHURE-Sep-2023_WhatisFHF_en.mp3',
    audio_af: 'audio/af/FHF-BROCHURE-Sep-2023_WhatisFHF_af.mp3',
    audio_xh: 'audio/xh/FHF-BROCHURE-Sep-2023_WhatisFHF_xh.mp3'
  },
  {
    id: 3,
    name: 'First Home Finance Presentation PPRA 2024',
    summary: 'shortsummary/first_home_finance_presentation_ppra_2024_.html',
    link: 'first_home_finance_presentation_ppra_2024_.pdf',
    audio_en: 'audio/en/First Home Finance_Booklet_en.mp3',
    audio_af: 'audio/af/First Home Finance_Booklet_af.mp3',
    audio_xh: 'audio/xh/First Home Finance_Booklet_xh.mp3'
  },
  {
    id: 4,
    name: 'REDBOOK (Part 1)',
    summary: 'shortsummary/REDBOOK_Part_1_v1-1.html',
    link: 'REDBOOK_Part_1_(Planning & design guidelines).pdf',
    audio_en: 'audio/en/REDBOOK_Part_1_(Planning & design guidelines)_en.mp3',
    audio_af: 'audio/af/REDBOOK_Part_1_(Planning & design guidelines)_af.mp3',
    audio_xh: 'audio/xh/REDBOOK_Part_1_(Planning & design guidelines)_xh.mp3'
  },
  {
    id: 5,
    name: 'Report on FLISP',
    summary: 'shortsummary/REPORT FLISP.html',
    link: 'REPORT FLISP.pdf',
    audio_en: 'audio/en/REPORT FLISP_en.mp3',
    audio_af: 'audio/af/REPORT FLISP_af.mp3',
    audio_xh: 'audio/xh/REPORT FLISP_xh.mp3'
  }
];